import React from "react";
import { Button, Modal } from "react-bootstrap";
import { useSelector } from "react-redux";
import Loader from "../loader/Loader";
import confirmationIcon from "../../assets/images/confirmation-icon.svg";

export default function ConfirmationModal({
  title,
  isOpen,
  toggle,
  onConfirm = () => { },
  message,
  fileName,
}) {
  const { isLoadingDelete, isLoadingSync, isLoadingUnsync, isArchiveLoading } =
    useSelector((state) => ({
      isLoadingDelete: state?.deleteDocument?.isLoading,
      isLoadingSync: state?.syncSlice?.isLoading,
      isLoadingUnsync: state?.unSyncSlice?.isLoading,
      isArchiveLoading: state?.archiveDocumentReducer?.isLoading,
    }));

  return (
    <div>
      {isLoadingDelete ||
        isLoadingSync ||
        isLoadingUnsync ||
        isArchiveLoading ? (
        <Loader />
      ) : (
        <Modal
          className="add-document-popup"
          show={isOpen}
          onHide={toggle}
          backdrop="static"
          // modalTransition={{ timeout: 2000 }}
          centered={true}
          dialogClassName="common-modal"
        >
          <Modal.Header>
            <h3 className="modal-title" id="Add_OrganizationLabel">
              {/* {title} */}
              Confirmation
            </h3>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={toggle}
            ></button>
          </Modal.Header>
          <Modal.Body>
            <div className="confirmation-block d-flex align-items-center">
              <img
                src={confirmationIcon}
                alt=""
                className="confirmation-icon"
              />
              <div>
                {fileName && <h4>{fileName}</h4>}
                <p>{message}</p>
              </div>
            </div>
            {/* <br />
            <p>{message}</p> */}
          </Modal.Body>
          <Modal.Footer>
            {/* <Button
              disabled={isLoadingDelete || isLoadingSync || isLoadingUnsync || isArchiveLoading}
              variant="btn btn-md-secondary"
              onClick={toggle}
            >
              No
            </Button> */}
            <Button
              disabled={
                isLoadingDelete ||
                isLoadingSync ||
                isLoadingUnsync ||
                isArchiveLoading
              }
              variant="btn btn-primary-md"
              onClick={onConfirm}
            >
              Yes
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    </div>
  );
}
